/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Viewuser1Inputs */

const en_btn_viewuser1 = /** @type {(inputs: Btn_Viewuser1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View user`)
};

/**
* | output |
* | --- |
* | "View user" |
*
* @param {Btn_Viewuser1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_viewuser1 = /** @type {((inputs?: Btn_Viewuser1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Viewuser1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_viewuser1(inputs)
});
export { btn_viewuser1 as "btn_viewUser" }